import { render, staticRenderFns } from "./SingleSignOnTable.vue?vue&type=template&id=5b5b4e20"
import script from "./SingleSignOnTable.vue?vue&type=script&lang=js"
export * from "./SingleSignOnTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports